/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Max_Event_DurationInputs */

const en_max_event_duration = /** @type {(inputs: Max_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum Event Duration (sec)`)
};

const fr_max_event_duration = /** @type {(inputs: Max_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée maximale d’un événement (s)`)
};

const de_max_event_duration = /** @type {(inputs: Max_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Ereignisdauer (Sek.)`)
};

const it_max_event_duration = /** @type {(inputs: Max_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata massima dell'evento (sec)`)
};

const ru_max_event_duration = /** @type {(inputs: Max_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальная продолжительность события (сек)`)
};

const es_max_event_duration = /** @type {(inputs: Max_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración máxima del evento (seg.)`)
};

const zh_cn2_max_event_duration = /** @type {(inputs: Max_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件最大持续时间（秒）`)
};

const ja_max_event_duration = /** @type {(inputs: Max_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大イベント継続時間（秒）`)
};

const hi_max_event_duration = /** @type {(inputs: Max_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम घटना अवधि (सेकंड)`)
};

const pt_pt2_max_event_duration = /** @type {(inputs: Max_Event_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração máxima do evento (seg)`)
};

/**
* | output |
* | --- |
* | "Maximum Event Duration (sec)" |
*
* @param {Max_Event_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const max_event_duration = /** @type {((inputs?: Max_Event_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Max_Event_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_max_event_duration(inputs)
	if (locale === "de") return de_max_event_duration(inputs)
	if (locale === "it") return it_max_event_duration(inputs)
	if (locale === "ru") return ru_max_event_duration(inputs)
	if (locale === "es") return es_max_event_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_max_event_duration(inputs)
	if (locale === "ja") return ja_max_event_duration(inputs)
	if (locale === "hi") return hi_max_event_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_max_event_duration(inputs)
	return en_max_event_duration(inputs)
});